const GeneralPrivacyNotice = () => {
  return (
    <div className="main-section main-body-bg">
      <div className="privacy-notice">
        <div className="container">
          <h1 className="h1-basic01 tc-head">General Privacy Notice</h1><br />
          <div class="main-section">
            <h2>1. Introduktion</h2>
            <p>
              Kreditz AB, org. nr. 559148-2400, Vendevägen 87, 182 32 Danderyd, Stockholm ("Kreditz", "vi",
              "oss") är ett svenskt bolag som tillhandahåller digitala tjänster för insamling, strukturering och
              analys av ekonomisk information. Våra tjänster används bland annat inom identitetsverifiering,
              regulatorisk efterlevnad eller som en del av kredit- samt andra bedömningar. Vi har tillstånd av
              Finansinspektionen att tillhandahålla kontoinformationstjänster.
            </p>
            <p>
              Du kommer i kontakt med oss när du använder en tjänst där vår teknik är integrerad, vanligtvis
              via en partner som tillhandahåller den aktuella tjänsten. Detta integritetsmeddelande förklarar
              hur vi samlar in, behandlar och skyddar dina personuppgifter när du besöker vår webbplats,
              kontaktar oss via formulär, använder våra tjänster genom en partner eller på annat sätt
              interagerar med oss. Mer information om hur vi behandlar personuppgifter finns under punkt 2.
            </p>
            <p>
              Integritetsmeddelandet omfattar även den behandling som sker när Kreditz uppfyller sina
              skyldigheter enligt Lag (2017:630) om åtgärder mot penningtvätt och finansiering av terrorism
              (<strong>“penningtvättslagen”</strong> eller <strong>“PTL”</strong>).
            </p>
            <p>
              För dig som kontaktar oss i samband med en <strong>rekryteringsprocess</strong> (t.ex. genom att skicka in
              en ansökan eller intresseanmälan), vänligen se vårt särskilda integritetsmeddelande för
              rekrytering (<a href="https://careers.kreditz.com/privacy-policy" target="_blank">här</a>).
            </p>
            <p>
              Vi använder cookies och liknande tekniker på vår webbplats för att förbättra funktionalitet,
              analysera användarbeteende och, i vissa fall, för marknadsföringssyften. Du kan själv välja vilka
              cookies du samtycker till, och du kan när som helst ändra eller återkalla ditt samtycke. Mer
              information om hur vi använder cookies och hur du hanterar dina inställningar finns i vår
              Cookiepolicy (<a href="https://careers.kreditz.com/cookie" target="_blank">här</a>).
            </p>
            <p>
              Vi har utsett ett <strong>dataskyddsombud</strong> som ska hjälpa oss att säkerställa att vi uppfyller dessa
              krav. Om du har några frågor kring hur vi fullgör våra skyldigheter är du välkommen att kontakta
              vårt dataskyddsombud via kontaktuppgifterna i avsnitt 10 nedan.
            </p>
          </div>

          <div class="main-section">
            <h2>2. Personuppgiftsbehandling</h2>
            <p>Här kan du läsa om hur vi samlar in och behandlar personuppgifter i olika delar av vår verksamhet. Vi beskriver vad vi gör med uppgifterna beroende på hur du kommer i kontakt med oss.</p>
            <p>För varje område förklarar vi vilka kategorier av personuppgifter som kan komma att behandlas, varför vi behandlar dessa uppgifter och i vilket syfte, vilken roll vi har enligt Europaparlamentets och rådets förordning (EU) 2016/679, även kallad dataskyddsförordningen <strong>(“GDPR”)</strong>.</p>
          </div>
          {/* 2.1 */}
          <div className="inner-section">
            <h3>2.1. Vid kontakt med Kreditz</h3>
            <div className="info-main">
              <div className="info-details">
                <div className="info-title">
                  <h5>Kategori</h5>
                </div>
                <div className="info-para">
                  <h5>
                    Beskrivning
                  </h5>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Situation</h5>
                </div>
                <div className="info-para">
                  <p>När du besöker vår webbplats, kontaktar oss via formulär, anmäler dig till nyhetsbrev, godkänner att bli kontaktad i marknadsföringssyfte eller besöker vårt kontor.</p>

                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Personuppgifter som behandlas</h5>
                </div>
                <div className="info-para">
                  <p>
                    - Kontaktuppgifter (namn, e-postadress, telefonnummer)
                  </p>
                  <p>
                    - IP-adress och teknisk information om din enhet
                  </p>
                  <p>
                    - Kamerabevakning med bildupptagning vid fysiskt besök
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Ändamål med behandlingen</h5>
                </div>
                <div className="info-para">
                  <p>- Kommunicera vid frågor och återkoppling</p>
                  <p>- Hantera prenumerationer och marknadsföringsutskick</p>
                  <p>- Analysera webbplatsanvändning</p>
                  <p>- Säkerställa teknisk drift och säkerhet</p>
                  <p>- Skydda verksamheten genom fysisk säkerhet</p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Vår roll enligt GDPR</h5>
                </div>
                <div className="info-para">
                  <p>
                    Kreditz är personuppgiftsansvarig för denna behandling. Vi bestämmer ändamålen och medlen för behandlingen och ansvarar för att behandlingen sker enligt GDPR.
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Ytterligare information</h5>
                </div>
                <div className="info-para">
                  <p>
                    Läs mer i vår Cookiepolicy för att få detaljer om hur vi använder cookies och tekniska data.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 2.2 */}
          <div className="inner-section">
            <h3>2.2.​Som användare av våra kontoinformationstjänster</h3>
            <div className="info-main">
              <div className="info-details">
                <div className="info-title">
                  <h5>Kategori</h5>
                </div>
                <div className="info-para">
                  <h5>
                    Beskrivning
                  </h5>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Situation</h5>
                </div>
                <div className="info-para">
                  <p>
                    När du använder en tjänst där vår teknik används för att hämta
                    kontoinformation från din bank eller kontoförvaltande institut,
                    behandlar vi personuppgifter på uppdrag av den partnern (t.ex. en
                    bank, kreditgivare eller annan tjänsteleverantör) vars tjänst du
                    använder.
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Personuppgifter som behandlas</h5>
                </div>
                <div className="info-para">
                  <p>
                    - Kontaktuppgifter (namn, e-post, telefonnummer)
                  </p>
                  <p>
                    - Personnummer
                  </p>
                  <p>
                    - Kontoinformation (t.ex. bank, saldon, transaktioner)
                  </p>
                  <p>
                    - Tekniska uppgifter (IP-adress, enhetstyp, webbläsare)
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Ändamål med behandlingen</h5>

                </div>
                <div className="info-para">
                  <p>- Hämta, strukturera och analysera kontoinformation</p>
                  <p>- Skapa finansiella insikter som en del av vår partners
                    kreditbedömning</p>
                  <p>- Säkerställa teknisk funktion och säkerhet</p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Vår roll enligt GDPR</h5>

                </div>
                <div className="info-para">
                  <p>
                    Kreditz är personuppgiftsansvarig för steget inhämtning av
                    kontoinformation från din bank eller kontoförvaltande institut.
                    Därefter, för vidare behandling av dina personuppgifter agerar vi som
                    personuppgiftsbiträde åt vår partner som är personuppgiftsansvarig.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 2.3 */}
          <div className="inner-section">
            <h3>2.3.​Vid hämtning av information från Skatteverket</h3>
            <div className="info-main">
              <div className="info-details">
                <div className="info-title">
                  <h5>Kategori</h5>
                </div>
                <div className="info-para">
                  <h5>
                    Beskrivning
                  </h5>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Situation</h5>
                </div>
                <div className="info-para">
                  <p>
                    När du använder en tjänst där Kreditz, på uppdrag av den partnern
                    vars tjänst du använder, hämtar uppgifter från Skatteverket.
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Personuppgifter som behandlas</h5>
                </div>
                <div className="info-para">
                  <p>
                    - Kontaktuppgifter (namn, e-post, telefonnummer)
                  </p>
                  <p>
                    - Personnummer
                  </p>
                  <p>
                    - Inkomstuppgifter
                  </p>
                  <p>
                    - Information om arbetsgivare
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Ändamål med behandlingen</h5>

                </div>
                <div className="info-para">
                  <p>- Utgöra en del av det underlag som används av partnern vid
                    kreditbedömning
                  </p>
                  <p>- Verifiera anställning</p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Vår roll enligt GDPR</h5>

                </div>
                <div className="info-para">
                  <p>
                    Kreditz är personuppgiftsbiträde och behandlar dina uppgifter på
                    uppdrag av vår partner som är personuppgiftsansvarig.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 2.4 */}
          <div className="inner-section">
            <h3>2.4.​Vid hämtning av uppgifter från bokföringssystem</h3>
            <div className="info-main">
              <div className="info-details">
                <div className="info-title">
                  <h5>Kategori</h5>
                </div>
                <div className="info-para">
                  <h5>
                    Beskrivning
                  </h5>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Situation</h5>
                </div>
                <div className="info-para">
                  <p>
                    När du använder en tjänst där Kreditz, på uppdrag av den partnern
                    vars tjänst du använder, hämtar uppgifter från ett bokföringssystem.
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Underlag och personuppgifter som behandlas</h5>
                </div>
                <div className="info-para">
                  <p>
                    - Resultaträkning och balansräkning
                  </p>
                  <p>
                    - Bokföringsunderlag som kan innehålla indirekta personuppgifter
                  </p>
                  <p>
                    - Uppgifter om tillgångar, skulder och eget kapital
                  </p>
                  <p>
                    - Andra relevanta ekonomiska uppgifter som behövs för att bedöma
                    företagets ekonomi
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Ändamål med behandlingen</h5>

                </div>
                <div className="info-para">
                  <p>
                    - Att utgöra en del av underlaget för att bedöma den ekonomiska
                    situationen inför eventuell kreditgivning
                  </p>
                  <p>
                    - Att verifiera företagets ekonomiska ställning, intäkter och
                    betalningsförmåga
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Vår roll enligt GDPR</h5>
                </div>
                <div className="info-para">
                  <p>
                    Kreditz är personuppgiftsbiträde och behandlar dina uppgifter på
                    uppdrag av vår partner som är personuppgiftsansvarig.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 2.4 */}
          <div className="inner-section">
            <h3>2.5. Behandling i enlighet med penningtvättslagen</h3>
            <div className="info-main">
              <div className="info-details">
                <div className="info-title">
                  <h5>Kategori</h5>
                </div>
                <div className="info-para">
                  <h5>
                    Beskrivning
                  </h5>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Situation</h5>
                </div>
                <div className="info-para">
                  <p>
                    När vi behandlar personuppgifter för att uppfylla våra rättsliga
                    skyldigheter enligt tillämpliga regler i penningtvättslagen.
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Personuppgifter som behandlas</h5>
                </div>
                <div className="info-para">
                  <p>
                    - Namn, personnummer, kontaktuppgifter
                  </p>
                  <p>
                    - ID-handlingar
                  </p>
                  <p>
                    - Syfte och art med affärsrelationen
                  </p>
                  <p>
                    - Uppgifter om politiskt utsatt ställning och verklig huvudman
                  </p>
                  <p>
                    - Transaktionshistorik och kundrelation hos Kreditz
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Ändamål med behandlingen</h5>

                </div>
                <div className="info-para">
                  <p>
                    - Kundkännedom (KYC)
                  </p>
                  <p>
                    - Riskbedömning och övervakning av affärsrelationer
                  </p>
                  <p>
                    - För att rapportera misstänkta aktiviteter till behörig myndighet
                  </p>
                  <p>
                    - Följa lagkrav för att motverka penningtvätt och finansiering av
                    terrorism
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Vår roll enligt GDPR</h5>
                </div>
                <div className="info-para">
                  <p>
                    Kreditz är personuppgiftsansvarig. Behandling sker självständigt
                    och enligt rättsliga skyldigheter.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="main-section">
            <h2>3.​Olika rättsliga grunder för behandling av dina personuppgifter​</h2>
            <div className="info-main">
              <div className="info-details">
                <div className="info-title">
                  <h5>Rättslig grund</h5>
                </div>
                <div className="info-para">
                  <h5>
                    Beskrivning
                  </h5>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Samtycke</h5>
                </div>
                <div className="info-para">
                  <p>
                    Vi behandlar dina personuppgifter med stöd av ditt uttryckliga
                    samtycke när:
                  </p>
                  <p>
                    -​ Du använder vår kontoinformationstjänst
                  </p>
                  <p>
                    -​ Du godkänner att vi hämtar uppgifter från Skatteverket eller
                    bokföringssystem
                  </p>
                  <p>
                    -​ Du samtycker till cookies på vår webbplats
                  </p>
                  <p>
                    -​ Du anmäler dig till nyhetsbrev eller godkänner
                    marknadsföringskontakt
                  </p>
                  <p>
                    Du kan när som helst återkalla ditt samtycke. Återkallandet
                    påverkar inte lagligheten av behandlingen innan det togs tillbaka.
                  </p>
                  <p>
                    Om du använder vår kontoinformationstjänst och vill du återkalla
                    ditt samtycke, vänligen klicka (<a href="#">här</a>).
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Rättslig förpliktelse</h5>
                </div>
                <div className="info-para">
                  <p>
                    Vi är skyldiga att behandla vissa personuppgifter för att uppfylla
                    lagkrav, särskilt när vi agerar som personuppgiftsansvarig vid
                    behandling enligt PTL. Detta omfattar:
                  </p>
                  <p>
                    - Genomföra kundkännedom (KYC)
                  </p>
                  <p>
                    - Riskbedöma och identifiera kunder
                  </p>
                  <p>
                    - Rapportera till behöriga myndigheter
                  </p>
                  <p>
                    - Bevara dokumentation under en viss tid
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Avtal</h5>

                </div>
                <div className="info-para">
                  <p>
                    Behandling sker när det är nödvändigt för att uppfylla ett avtal
                    mellan dig och Kreditz eller den partner vars tjänst du använder.
                  </p>
                </div>
              </div>
              <div className="info-details">
                <div className="info-title">
                  <h5>Berättigat intresse</h5>
                </div>
                <div className="info-para">
                  <p>
                    Vi behandlar personuppgifter för att tillgodose våra berättigade
                    intressen när:
                  </p>
                  <p>
                    - Vi kommunicerar med dig
                  </p>
                  <p>
                    - Vi analyserar webbplatsanvändning

                  </p>
                  <p>
                    - Vi säkrar vår tekniska drift och informationssäkerhet

                  </p>
                  <p>
                    - Vi kamerabevakar våra lokaler

                  </p>
                  <p>
                    - Vi kan komma att anonymisera personuppgifter för att förbättra
                    våra modeller och tjänsters kvalitet
                  </p>
                  <p>
                    Vid varje sådan behandling gör vi en intresseavvägning för att
                    säkerställa att dina rättigheter inte väger tyngre än vårt intresse.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="main-section">
            <h2>4.​Vem vi delar dina uppgifter med​</h2>
            <div className="info-main">
              <p>
                Vi delar dina personuppgifter med tjänsteleverantörer som agerar som våra
                personuppgiftsbiträden. De får endast behandla dina uppgifter enligt våra instruktioner och får
                inte använda dem för egna syften. Dessa mottagare tillhör följande kategorier:
              </p>
              <div className="padding-left-5">
                <p>
                  -​ Molntjänstleverantörer för hosting och datalagring
                </p>
                <p>
                  -​ Kommunikationstjänster för e-post
                </p>
                <p>
                  -​ SMS-kommunikationsplattformar
                </p>
                <p>
                  -​ Marknadsföringstjänst för e-postutskick
                </p>
                <p>
                  -​ Optimering av våra tjänster och webbplats
                </p>
                <p>
                  -​ Säkerhets- och utvecklingstjänster
                </p>
              </div>
              <p>
                I vissa fall är vi skyldiga att dela personuppgifter med behöriga myndigheter när detta krävs
                enligt penningtvättslagen. Sådan delning sker utan föregående samtycke från dig och kan ske
                utan att du informeras om det.
              </p>
              <p>
                Vi varken säljer eller delar dina personuppgifter med några andra tredje parter.
              </p>
            </div>
          </div>

          <div class="main-section">
            <h2>5.​Internationella dataöverföringar​</h2>
            <div className="info-main">
              <p>
                Om vi överför dina personuppgifter utanför Europeiska ekonomiska samarbetsområdet (EES) säkerställer vi lämpliga skyddsåtgärder, såsom användning av EU-kommissionens standardavtalsklausuler (SCC).
              </p>
            </div>
          </div>

          <div class="main-section">
            <h2>6.​Lagring av personuppgifter​</h2>
            <div className="info-main">
              <p>
                Vi sparar dina personuppgifter endast så länge som det är nödvändigt för respektive ändamål eller för att uppfylla lagkrav. Personuppgifter anonymiseras eller raderas när de inte längre behövs.
              </p>
              <p>
                Vid behandling som sker enligt tillämplig lagstiftning, såsom PTL, bokföringslagen och årsredovisningslagen, bevarar vi personuppgifter i enlighet med gällande lagkrav.
              </p>
            </div>
          </div>

          <div class="main-section">
            <h2>7.​ Säkerhetsåtgärder​</h2>
            <div className="info-main">
              <p>
                Kreditz, i egenskap av personuppgiftsbiträde, har följande säkerhets- och organisatoriska åtgärder på plats:
              </p>
              <div className="padding-left-5">
                <p>
                  -​ Kryptering av personuppgifter både vid lagring och under överföring
                </p>
                <p>
                  - Åtkomstkontroller med behörighetsstyrning baserad på roller
                </p>
                <p>
                  - Kontinuerlig systemövervakning och loggning av revisioner
                </p>
                <p>
                  - Etablera säkra utvecklingsrutiner och regelbundna säkerhetstester
                </p>
                <p>
                  - Interna utbildningar, styrdokument och policyer för integritet och
                </p>
                <p>
                  - informationssäkerhet
                </p>
                <p>
                  - Åtgärder för dataminimering
                </p>
              </div>
            </div>
          </div>

          <div class="main-section">
            <h2>8.​Dina rättigheter</h2>
            <div className="info-main">
              <p>
                Du har rätt att:
              </p>
              <div className="padding-left-5">
                <p>
                  -​ Begära tillgång till dina uppgifter
                </p>
                <p>
                  - Begära rättelse av felaktiga uppgifter
                </p>
                <p>
                  - Begära radering av dina uppgifter (“rätt att bli bortglömd”)
                </p>
                <p>
                  - Invända mot viss behandling
                </p>
                <p>
                  - Begära dataportabilitet
                </p>
              </div>
              <p>
                Kontakta oss via kontaktuppgifterna nedan om du vill utöva någon av dessa rättigheter.
              </p>
            </div>
          </div>

          <div class="main-section">
            <h2>9.​Tillsynsmyndighet</h2>
            <div className="info-main">
              <p>
                Om du anser att dina personuppgifter behandlas på ett felaktigt sätt, eller om dina rättigheter enligt GDPR inte har respekterats, kan du lämna in ett klagomål till relevant dataskyddsmyndighet:
              </p>
              <p>
                <strong>Integritetsskyddsmyndigheten (IMY)</strong><br />
                Webbplats: <a href="https://www.imy.se" target="_blank">www.imy.se</a>
              </p>
            </div>
          </div>

          <div class="main-section">
            <h2>10.​Kontakta oss</h2>
            <div className="info-main">
              <p>
                Om du har frågor om detta integritetsmeddelande eller hur vi behandlar dina personuppgifter kan du kontakta oss på:
              </p>
              <p>
                Dataskyddsombud<br />
                Kreditz AB​<br />
                Vendevägen 87, 182 32 Danderyd
              </p>
              <p>
                E-post: <a href="mailto:privacy@kreditz.com​">privacy@kreditz.com​</a>
              </p>
              <p>
                Senast uppdaterad: 202505
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default GeneralPrivacyNotice;